export default function scrollToTheFirstErrorOnPage() {
  window.requestAnimationFrame(() => {
    const errorElement = document.getElementsByClassName("form-field-error");
    if (errorElement?.length) {
      const firstErrorEle = errorElement?.[0];
      const parentElement = firstErrorEle?.parentElement;
      parentElement.scrollIntoView(true);
    }
  });
}
  